import KAPIntakeForm from '././KAPIntakeForm.js';

export default KAPIntakeForm;
